"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomEmote = void 0;
exports.RoomEmote = {
    laugh: "😂",
    cry: "😭",
    angry: "😡",
    thumbsUp: "👍",
    thumbsDown: "👎",
    heart: "❤️",
    fire: "🔥",
    clap: "👏",
    surprised: "😱",
    cool: "😎",
    thinking: "🤔",
    wave: "👋",
};
